module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_14_m.57f8dfd7dc62b61f741f5197105c4862.png";